import { Link } from "react-router-dom";
import { sanitizeHtml } from "../lib/sanitize";
import { Radar, ArrowLeft, Scale } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getLegal } from "../i18n/legal";
import LanguageSwitcher from "../components/LanguageSwitcher";

const GOLD = "#C6A87C";

const Section = ({ n, title, html }) => (
  <section className="mt-10" data-testid={`cgu-section-${n}`}>
    <h2 className="font-display text-xl text-[#0F172A]">{n}. {title}</h2>
    <div
      className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600 [&_ul]:space-y-1"
      dangerouslySetInnerHTML={sanitizeHtml(html)}
    />
  </section>
);

export default function ConditionsGenerales() {
  const { i18n } = useTranslation();
  const L = getLegal(i18n.language);

  return (
    <div className="min-h-screen bg-white" data-testid="cgu-page">
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2" data-testid="cgu-home-link">
            <Radar className="h-5 w-5" style={{ color: GOLD }} strokeWidth={1.8} />
            <span className="font-display text-lg text-[#0F172A]">RADAR</span>
          </Link>
          <div className="flex items-center gap-3">
            <LanguageSwitcher variant="light" />
            <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0F172A]" data-testid="cgu-back-link">
              <ArrowLeft className="h-4 w-4" /> {L.back}
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-14">
        <p className="text-xs font-semibold uppercase tracking-[0.18em]" style={{ color: GOLD }}>{L.kicker}</p>
        <h1 className="mt-3 font-display text-3xl tracking-tight text-[#0F172A] sm:text-4xl">
          {L.title}
        </h1>
        <p className="mt-3 text-sm text-slate-500">{L.updatedLabel} : {L.updatedDate}</p>

        <div
          className="mt-6 flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
          data-testid="cgu-binding-note"
        >
          <Scale className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" strokeWidth={1.8} />
          <p>{L.binding}</p>
        </div>

        {L.sections.map((s, i) => (
          <Section key={i} n={i + 1} title={s.t} html={s.h} />
        ))}

        <div className="mt-12 border-t border-slate-200 pt-8">
          <Link to="/register" className="inline-flex items-center gap-2 rounded-full bg-[#0F172A] px-6 py-3 text-sm font-semibold text-white transition-transform hover:scale-[1.03]" data-testid="cgu-register-link">
            {L.registerCta}
          </Link>
        </div>
      </main>
    </div>
  );
}
